import React from 'react'
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setErrorState } from '../actions/api'
import { doRegister } from '../actions/auth'
import Loading from '../components/loading'
import add from '../images/plus.png'
import { validateAge, validateDateOfBirth, validateDay, validateExpirationMonth, validateExpirationYear, validateFirstName, validateLastName, validateMedicareNumber, validateMonth, validateRegNumber, validateYear } from '../util/validation'
import RegTitleCard from './registrationTitleCard'


class DependentForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRegisterError: false,
            errCode: null,
            registerErrorMessage: null,
            firstName: null,
            lastName: null,
            expirationDateMonth: '',
            expirationDateYear: '',
            dateOfBirth: null,
            dobYear: '',
            dobMonth: '',
            dobDay: '',
            medicareNumber: '',
            issuer: 'NB',
            regNumber: '',
            showModal: false,
            disableBttn: true,
            hasAccepted: false,
            validCheck: {
                regNumber: false,
                firstName: false,
                lastName: false,
                expirationDateMonth: false,
                expirationDateYear: false,
                dateOfBirth: false,
                dobDay: false,
                dobMonth: false,
                dobYear: false,
                medicareNumber: false,
            },
            errors: {
                regNumber: null,
                firstName: null,
                lastName: null,
                expirationDateMonth: null,
                expirationDateYear: null,
                dateOfBirth: null,
                dobDay: null,
                dobMonth: null,
                dobYear: null,
                medicareNumber: null,
            },
            checkBoxError: null,
        };
    }

    componentDidUpdate(prevProps, prevState){
        // Check valid inputs to disable button
        let allValidCurr = Object.keys(this.state.validCheck).every((e) => this.state.validCheck[e]);
        let allValidPrev = Object.keys(prevState.validCheck).every((e) => prevState.validCheck[e]);
        if(this.state.hasAccepted !== prevState.hasAccepted && allValidCurr){
            if(allValidCurr && this.state.hasAccepted){
                this.setState({ disableBttn: false });
            } else {
                this.setState({ disableBttn: true })
            }
        } else if(this.state.hasAccepted && allValidCurr !== allValidPrev){
            if(allValidCurr && this.state.hasAccepted){
                this.setState({ disableBttn: false });
            } else {
                this.setState({ disableBttn: true })
            }
        }

        // Check if DOB is valid
        //TODO HERE
        let prevDob = prevState.dobYear + "-" + prevState.dobMonth.padStart(2,"0") + "-" + prevState.dobDay.padStart(2,"0");
        let currDob = this.state.dobYear + "-" + this.state.dobMonth.padStart(2,"0") + "-" + this.state.dobDay.padStart(2,"0");
        if(currDob !== prevDob){
            if(this.state.dobDay !== null && this.state.dobMonth !== null && this.state.dobYear !== null && validateYear(this.state.dobYear)){
                this.validateDOB();
            }
        }

        //Change validation errors on language change
        if(this.props.strings !== prevProps.strings){
            let newErrors = this.changeErrorLanguage(prevState.errors, this.state.errors, prevProps.strings);
            let checkBoxError = prevState.checkBoxError;
            if (checkBoxError!= null){
                checkBoxError = this.props.strings.REG_ERROR_CHECKBOX_ERROR;
            }
            this.setState({errors:newErrors, checkBoxError: checkBoxError});
        }
    }

    changeErrorLanguage=(oldErrors, newErrors, oldStrings)=>{
        switch(oldErrors.regNumber){
            case(oldStrings.REG_ERROR_INVALID_REGISTRATION_NUMBER):
                newErrors.regNumber =this.props.strings.REG_ERROR_INVALID_REGISTRATION_NUMBER;
                break;
            default:
                newErrors.regNumber = null;
        }

        switch(oldErrors.firstName){
            case(oldStrings.REG_ERROR_INVALID_NAME):
                newErrors.firstName = this.props.strings.REG_ERROR_INVALID_NAME;
                break;
            case(oldStrings.REG_ERROR_INVALID_FIRST_NAME):
                newErrors.firstName = this.props.strings.REG_ERROR_INVALID_FIRST_NAME;
                break;
            default:
                newErrors.firstName = null;
        }

        switch(oldErrors.lastName){
            case(oldStrings.REG_ERROR_INVALID_LAST_NAME):
                newErrors.lastName = this.props.strings.REG_ERROR_INVALID_LAST_NAME;
                break;
            case(oldStrings.REG_ERROR_INVALID_NAME):
                newErrors.lastName = this.props.strings.REG_ERROR_INVALID_NAME;
                break;
            default:
                newErrors.lastName = null;
        }

        switch(oldErrors.expirationDateMonth){
            case(oldStrings.REG_ERROR_INVALID_EXPIRATION_DATE):
                newErrors.expirationDateMonth = this.props.strings.REG_ERROR_INVALID_EXPIRATION_DATE;
                break;
            case(oldStrings.REG_ERROR_INVALID_EXPIRATION_MONTH):
                newErrors.expirationDateMonth = this.props.strings.REG_ERROR_INVALID_EXPIRATION_MONTH;
                break;
            default:
                newErrors.expirationDateMonth = null;
        }

        switch(oldErrors.expirationDateYear){
            case(oldStrings.REG_ERROR_INVALID_EXPIRATION_YEAR):
                newErrors.expirationDateYear = this.props.strings.REG_ERROR_INVALID_EXPIRATION_YEAR;
                break;
            default:
                newErrors.expirationDateYear = null;
        }

        switch(oldErrors.dateOfBirth){
            case(oldStrings.REG_ERROR_INVALID_DOB):
                newErrors.dateOfBirth = this.props.strings.REG_ERROR_INVALID_DOB;
                break;
            case(oldStrings.REG_ERROR_INVALID_DOB_DAY):
                newErrors.dateOfBirth = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
                break;
            default:
                newErrors.dateOfBirth = null;
        }

        switch(oldErrors.dobDay){
            case(oldStrings.REG_ERROR_INVALID_DOB_DAY):
                newErrors.dobDay = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
                break;
            case(oldStrings.REG_ERROR_DOB_DAY_OUT_OF_RANGE):
                newErrors.dobDay = this.props.strings.REG_ERROR_DOB_DAY_OUT_OF_RANGE;
            default:
                newErrors.dobDay = null;
        }

        switch(oldErrors.dobMonth){
            case(oldStrings.REG_ERROR_INVALID_DOB_MONTH):
                newErrors.dobMonth = this.props.strings.REG_ERROR_INVALID_DOB_MONTH;
                break;
            case(oldStrings.REG_ERROR_DOB_MONTH_OUT_OF_RANGE):
                newErrors.dobMonth = this.props.strings.REG_ERROR_DOB_MONTH_OUT_OF_RANGE;
                break;
            default:
                newErrors.dobMonth = null;
        }

        switch(oldErrors.dobYear){
            case(oldStrings.REG_ERROR_INVALID_DOB_YEAR):
                newErrors.dobYear = this.props.strings.REG_ERROR_INVALID_DOB_YEAR;
                break;
            default:
                newErrors.dobYear = null;
        }

        switch(oldErrors.medicareNumber){
            case(oldStrings.REG_ERROR_INVALID_MEDICARE_NUMBER):
                newErrors.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
                break;
            case(oldStrings.REG_ERROR_MEDICARE_FIELD_NOT_ENOUGH_DIGITS):
                newErrors.medicareNumber = this.props.strings.REG_ERROR_MEDICARE_FIELD_NOT_ENOUGH_DIGITS;
                break;
            default:
                newErrors.medicareNumber = null;
        }
        return newErrors;
    }
    
    handleValids = (childInfo) => {
        this.setState({ childInfo: childInfo });
        if(childInfo){
            this.setState({ isValid: true });
        } else{
            this.setState({ isValid: false });
        }
    }

    makeRegDto() {
        console.log("Creating DTO...");
        if(this.state.expirationDateMonth < 2){
            this.setState({expirationDateMonth: '0'+this.state.expirationDateMonth });
        }
        let dto = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            dateOfBirth: this.state.dateOfBirth,
            regCode: this.state.regNumber,
            hcn: this.state.medicareNumber,
            hcnIssuer: this.state.issuer,
            hcnExpiry: this.state.expirationDateMonth+"/"+this.state.expirationDateYear,
            approvedParent: this.state.hasAccepted,
        };
        console.log("DTO created.");
        return dto;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if(this.state.disableBttn){
            this.regNumInput.focus();
            this.firstNameInput.focus();
            this.lastNameInput.focus();
            this.medicareInput.focus();
            this.expiryMonthInput.focus();
            this.expiryYearInput.focus();
            this.dobDayInput.focus();
            this.dobMonthInput.focus();
            this.dobYearInput.focus();
            this.sumitButton.focus();
            if(this.state.hasAccepted!== true){
                this.setState({checkBoxError:this.props.strings.REG_ERROR_CHECKBOX_ERROR});
            }
            this.handleScroll();
        }
        else{
            this.setState({isRegisterError: false, registerErrorMessage: null});
            let dto = this.makeRegDto();
            let resp = this.props.dispatch(doRegister(dto))
                .then(() => {
                    console.log("Registration completed.");
                    setTimeout(() => {
                        this.props.history.push("/app");
                    }, 500);
                })
                .catch(err => {
                    // FIXME Handle errors here!
                    this.setState({disableBttn: true});
                    this.setState({ hasAccepted: !this.state.hasAccepted });
                    this.setState({ errCode: err.errorObj.code });
                    console.log("Error Object\n",err.errorObj);
                    console.log("Dependant Form Error Message",err.message);
                    if(err.code === 'IIE'){
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM, errCode: err.code});
                    } else if(err.code === 'IPE'){
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD, errCode: err.code});
                    } else if(err.code === 'CUE'){
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_CREATE_USER, errCode: err.code});
                    } else if(err.code === 'UNAE'){
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.USUERNAME_EXISTS_ERROR_MESSAGE, errCode: err.code});
                    } else if(err.code === '013'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '014'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '015'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '101'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '102'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '103'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '104'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '106'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '107'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '111'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '112'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '113') {
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '114') {
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '115') {
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === '999'){
                        this.setState({isRegisterError: true, registerErrorMessage: err.errorObj.message, errCode: err.code});
                    } else if(err.code === 'DAE'){
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_READD_CHILD, errCode: err.code});
                    } else if(err.code === 'ARE'){
                        this.props.dispatch(setErrorState(true, err.message.message, true));
                    } else {
                        this.setState({isRegisterError: true, registerErrorMessage: this.props.strings.REG_ERROR_MESSAGE, errCode: err.code});
                    }
                    // Scroll to top so user can see error message
                    this.handleScroll();
                });;
        }
    }

    handleScroll(){
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    handleRegNumberChange  = (e) => {
        let err = this.state.errors;
        err.regNumber = null;
        let val = e.target.value.toUpperCase().trim();
        if (validateRegNumber(val)) {
            this.setState({regNumber: val, errors: err, validCheck: {...this.state.validCheck, regNumber:true }});
        } else if(val == ''){
            err.regNumber = this.props.strings.REG_ERROR_INVALID_REGISTRATION_NUMBER;
            this.setState({regNumber: val, errors: err, validCheck: { regNumber: false}});
        } else{
            if(!validateRegNumber(val)){
                this.setState({regNumber: val, errors: err, validCheck: { regNumber: false}});
                return;
            }
        }
    }

    handleFirstNameChange = (e) => {
        let err = this.state.errors;
        err.firstName = null;
        let val = e.target.value.toUpperCase();
        if (validateFirstName(val)) {
            this.setState({firstName: val, errors: err, validCheck: {...this.state.validCheck, firstName: true}});
        } else {
            if (val == ""){
                err.firstName = this.props.strings.REG_ERROR_INVALID_FIRST_NAME;
            } else {
                err.firstName = this.props.strings.REG_ERROR_INVALID_NAME;
            }
            this.setState({firstName: val, errors: err, validCheck: {...this.state.validCheck, firstName: false}});
        }
    }

    handleFinalFirstName = (e) => {
        let err = this.state.errors;
        err.firstName = null;
        let val = e.target.value.toUpperCase().trim();
        if (validateFirstName(val)) {
            this.setState({firstName: val, errors: err, validCheck: {...this.state.validCheck, firstName: true}});
        } else {
            if (val == ""){
                err.firstName = this.props.strings.REG_ERROR_INVALID_FIRST_NAME;
            } else {
                err.firstName = this.props.strings.REG_ERROR_INVALID_NAME;
            }
            this.setState({firstName: val, errors: err, validCheck: {...this.state.validCheck, firstName: false}});
        }
    }

    handleLastNameChange = (e) => {
        let err = this.state.errors;
        err.lastName = null;
        let val = e.target.value.toUpperCase();
        if (validateLastName(val) && val !== null) {
            this.setState({lastName: val, errors: err, validCheck: {...this.state.validCheck, lastName: true}});
        } else {
            if (val == ""){
                err.lastName = this.props.strings.REG_ERROR_INVALID_LAST_NAME;
            } else {
                err.lastName = this.props.strings.REG_ERROR_INVALID_NAME;
            }
            this.setState({lastName: val, errors: err, validCheck: {...this.state.validCheck, lastName: false}});
        }
    }

    handleFinalLastName = (e) => {
        let err = this.state.errors;
        err.lastName = null;
        let val = e.target.value.toUpperCase().trim();
        if (validateLastName(val) && val !== null) {
            this.setState({lastName: val, errors: err, validCheck: {...this.state.validCheck, lastName: true}});
        } else {
            if (val == ""){
                err.lastName = this.props.strings.REG_ERROR_INVALID_LAST_NAME;
            } else {
                err.lastName = this.props.strings.REG_ERROR_INVALID_NAME;
            }
            this.setState({lastName: val, errors: err, validCheck: {...this.state.validCheck, lastName: false}});
        }
    }

    checkFinalExpirationDateMonth =(e) =>{
        let err = this.state.errors;
        err.expirationDateMonth = null;
        let val = e.target.value;
        if(val === '' || val === null) {
            err.expirationDateMonth = this.props.strings.REG_ERROR_INVALID_EXPIRATION_DATE;
            this.setState({expirationDateMonth: val, errors: err, validCheck: {...this.state.validCheck, expirationDateMonth: false}});
        }else if( val==='0'){
            err.expirationDateMonth = this.props.strings.REG_ERROR_INVALID_EXPIRATION_MONTH;
            this.setState({expirationDateMonth: val, errors: err, validCheck: {...this.state.validCheck, expirationDateMonth: false}});
        }else if(validateExpirationMonth(val)){
            this.setState({expirationDateMonth: val, errors: err, validCheck: {...this.state.validCheck, expirationDateMonth: true}});
        }else{
            err.expirationDateMonth = this.props.strings.REG_ERROR_INVALID_EXPIRATION_MONTH;
            this.setState({expirationDateMonth: val, errors: err, validCheck: {...this.state.validCheck, expirationDateMonth: false}});
        }
    }

    handleExpirationDateMonth = (e) =>{
        let err = this.state.errors;
        err.expirationDateMonth = null;
        let val = e.target.value;
        if (validateExpirationMonth(val)) {
            this.setState({expirationDateMonth: val, errors: err, validCheck: {...this.state.validCheck, expirationDateMonth: true}});
        }else {
            if (!validateExpirationMonth(val)) {
                return;
            }
        }
    }

    handleExpirationDateYear = (e) =>{
        let err = this.state.errors;
        err.expirationDateYear = null;
        let val = e.target.value;
        if (validateExpirationYear(val)) {
            this.setState({expirationDateYear: val, errors: err, validCheck: {...this.state.validCheck, expirationDateYear: true}});
        } else if(val === '' || val === null) {
            err.expirationDateYear = this.props.strings.REG_ERROR_INVALID_EXPIRATION_YEAR;
            this.setState({expirationDateYear: val, errors: err, validCheck: {...this.state.validCheck, expirationDateYear: false}});
        } else {
            if (!validateExpirationYear(val)) { return; }
        }
    }

    handleFinalExpirationDateYear = (e) =>{
        let err = this.state.errors;
        err.expirationDateYear = null;
        let val = e.target.value;
        if(val.length<4){
            err.expirationDateYear = this.props.strings.REG_ERROR_INVALID_EXPIRATION_YEAR;
            this.setState({expirationDateYear: val, errors: err, validCheck: {...this.state.validCheck, expirationDateYear: false}});
        }
        else if (validateExpirationYear(val)) {
            this.setState({expirationDateYear: val, errors: err, validCheck: {...this.state.validCheck, expirationDateYear: true}});
        } else if(val === '' || val === null) {
            err.expirationDateYear = this.props.strings.REG_ERROR_INVALID_EXPIRATION_YEAR;
            this.setState({expirationDateYear: val, errors: err, validCheck: {...this.state.validCheck, expirationDateYear: false}});
        }
        else {
            if (!validateExpirationYear(val)) { return; }
        }
    }

    handleDateOfBirthYearChange = (e) =>{
        let err =this.state.errors;
        err.dobYear = null;
        let val = e.target.value;
        if (val.length<=4 && val.match(/^[0-9]{0,4}$/)) {
            this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
        }
        else{
            return;
        }
    }

    handleFinalDateOfBirthYearChange = (e)=>{
        let err = this.state.errors;
        err.dobYear = null;
        let val = e.target.value;
        if (val.length!=4){
            err.dobYear = this.props.strings.REG_ERROR_INVALID_DOB_YEAR;
            this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
        }
        else if(validateYear(val) && val !== null){
            this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: true}});
        } else {
            err.dobYear = this.props.strings.REG_ERROR_INVALID_DOB_YEAR;
            this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
        }
    }

    handleDateOfBirthMonthChange = (e) => {
        let err = this.state.errors;
        err.dobMonth = null;
        // let val = e.target.value.padStart(2, '0');
        let val = e.target.value;
        if (val.length<=2 && val.match(/^[0-9]{0,2}$/)) {
            if(Number(val) !== NaN && Number(val) <= 12 && Number(val) > 0){
                this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: true}});
            }
            else{
                err.dobMonth= this.props.strings.REG_ERROR_DOB_MONTH_OUT_OF_RANGE;
                this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: false}});
            }
        }
        else{
            return;
        }
    }

    handleFinalDateOfBirthMonthChange = (e) => {
        let err = this.state.errors;
        err.dobMonth = null;
        // let val = e.target.value.padStart(2, '0');
        let val = e.target.value;
        if(val === "" || val === null ||val === undefined){
            err.dobMonth = this.props.strings.REG_ERROR_INVALID_DOB_MONTH;
            this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: false}});
        }
        else if(validateMonth(val, this.state.dobDay) && val !== null){
            this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: true}});
        } 
        else {
            err.dobMonth = this.props.strings.REG_ERROR_DOB_MONTH_OUT_OF_RANGE;
            this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: false}});
        }
    }

    handleDateOfBirthDayChange = (e) => {
        let err = this.state.errors;
        err.dobDay = null;
        let val = e.target.value.trim();
        // let val = e.target.value.trim().padStart(2, '0');
        if (val.length<=2 && val.match(/^[0-9]{0,2}$/)) {
            if(Number(val) !== NaN && Number(val) <= 31 && Number(val) > 0){
                this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: true}});
            }
            else{
                err.dobDay= this.props.strings.REG_ERROR_DOB_DAY_OUT_OF_RANGE;
                this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
            }
        }
        else{
            return;
        }
    }

    handleFinalDateOfBirthDay =(e) =>{
        let err = this.state.errors;
        err.dobDay = null;
        let val = e.target.value.trim();
        if (val === undefined || val === null || val ===""){
            err.dobDay = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
            this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
        }
        else if (validateDay(val, this.state.dobMonth) && val !== null) {
            this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: true}});
        } else {
            err.dobDay = this.props.strings.REG_ERROR_DOB_DAY_OUT_OF_RANGE;
            this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
        }
    }

    // handleDateOfBirthYearChange = (e) => {
    //     let err = this.state.errors;
    //     err.dobYear = null;
    //     let val = e.target.value;
    //     if(validateYear(val) && val !== null){
    //         this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: true}});
    //     } else if (val.length<=4 && val.match(/^[0-9]{0,4}$/)) {
    //         this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
    //     }else{
    //         return;
    //     }
    // }

    // handleFinalDateOfBirthYearChange = (e)=>{
    //     let err = this.state.errors;
    //     err.dobYear = null;
    //     let val = e.target.value;
    //     if (val.length!=4){
    //         err.dobYear = this.props.strings.REG_ERROR_INVALID_DOB_YEAR;
    //         this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
    //     }
    //     else if(validateYear(val) && val !== null){
    //         this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: true}});
    //     } else {
    //         err.dobYear = this.props.strings.REG_ERROR_INVALID_DOB_YEAR;
    //         this.setState({dobYear: val, errors: err, validCheck: {...this.state.validCheck, dobYear: false}});
    //     }
    // }

    // handleDateOfBirthMonthChange = (e) => {
    //     let err = this.state.errors;
    //     err.dobMonth = null;
    //     // let val = e.target.value.padStart(2, '0');
    //     let val = e.target.value;
    //     if(validateMonth(val, this.state.dobDay) && val !== null){
    //         this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: true}});
    //     } 
    //     else {
    //         return;
    //     }
    // }

    // handleFinalDateOfBirthMonthChange = (e) => {
    //     let err = this.state.errors;
    //     err.dobMonth = null;
    //     // let val = e.target.value.padStart(2, '0');
    //     let val = e.target.value;
    //     if(val === "" || val === null || val ==="0" ||val === undefined){
    //         err.dobMonth = this.props.strings.REG_ERROR_INVALID_DOB_MONTH;
    //         this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: false}});
    //     }
    //     else if(validateMonth(val, this.state.dobDay) && val !== null){
    //         this.setState({dobMonth: val, errors: err, validCheck: {...this.state.validCheck, dobMonth: true}});
    //     } 
    //     else {
    //         return;
    //     }
    // }

    // handleDateOfBirthDayChange = (e) => {
    //     let err = this.state.errors;
    //     err.dobDay = null;
    //     let val = e.target.value.trim();
    //     // let val = e.target.value.trim().padStart(2, '0');
    //     if(val === "" || val === null){
    //         err.dobDay = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
    //         this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
    //     }
    //     else if (validateDay(val, this.state.dobMonth) && val !== null) {
    //         this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: true}});
    //     } else {
    //         return;
    //     }
    // }

    // handleFinalDateOfBirthDay =(e) =>{
    //     let err = this.state.errors;
    //     err.dobDay = null;
    //     let val = e.target.value.trim();
    //     if (val=="0" || val === undefined || val === null){
    //         err.dobDay = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
    //         this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
    //     }
    //     else if (validateDay(val, this.state.dobMonth) && val !== null) {
    //         this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: true}});
    //     } else {
    //         err.dobDay = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
    //         this.setState({dobDay: val, errors: err, validCheck: {...this.state.validCheck, dobDay: false}});
    //     }
    // }

    checkFinalMedicareNumber = (e)=> {
        let err = this.state.errors;
        let val = e.target.value.trim();
        if(val === null || val ==="" || val ===undefined){
            err.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        }
        else if(!(validateMedicareNumber(val))){
            err.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        }
        else if(val.length!==9){
            err.medicareNumber = this.props.strings.REG_ERROR_MEDICARE_FIELD_NOT_ENOUGH_DIGITS;
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        }
    }

    handleMedicareNumberChange = (e) => {
        let err = this.state.errors;
        err.medicareNumber = null;
        let val = e.target.value.trim();
        if (validateMedicareNumber(val)) {
            if(val.length === 9){
                this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: true}});
            } else {
                this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
            }
        } else if(val === '' || val === null) {
            err.medicareNumber = this.props.strings.REG_ERROR_INVALID_MEDICARE_NUMBER;
            this.setState({medicareNumber: val, errors: err, validCheck: {...this.state.validCheck, medicareNumber: false}});
        } else {
            if (!validateMedicareNumber(val)) { return; }
        }
    }

    handleIssuerSelectChange = (e) => {
        let err = this.state.errors;
        err.issuer = null;
        let val = e.target.value.padStart(2, '0');
        if(val !== ""){
            this.setState({issuer: val, errors: err, validCheck: {...this.state.validCheck, issuer: true}});
        } else {
            err.issuer = this.props.strings.REG_ERROR_INVALID_ISSUER_NUMBER;
            this.setState({issuer: e.target.value, errors: err, validCheck: {...this.state.validCheck, issuer: false}});
        }
    }

    checkAccepted = () => {
        this.setState({ checkBoxError: null, hasAccepted: !this.state.hasAccepted });
        console.log(this.state.validCheck);
    }

    //TODO HERE
    validateDOB(){
        let err = this.state.errors;
        err.dateOfBirth = null;
        if(this.state.dobDay !== null && this.state.dobMonth !== null && this.state.dobYear !== null){
            let dobDayMonth = this.state.dobDay.padStart(2,"0")+ "-" + this.state.dobMonth.padStart(2,"0");
            let dob = this.state.dobYear + "-" + this.state.dobMonth.padStart(2,"0") + "-" + this.state.dobDay.padStart(2,"0");
            if(validateDateOfBirth(dob)){
                if (validateAge(dob)){
                    this.setState({dateOfBirth: dob, errors: err, validCheck: { ...this.state.validCheck, dateOfBirth: true }});
                }
                else{
                    err.dateOfBirth=this.props.strings.REG_ERROR_INVALID_DOB;
                    this.setState({dateOfBirth:dob, errors:err, validCheck: {...this.state.validCheck, dateOfBirth:false}})
                }
            } else {
                err.dateOfBirth = this.props.strings.REG_ERROR_INVALID_DOB_DAY;
                this.setState({dateOfBirth: dob, errors: err, validCheck: { ...this.state.validCheck, dateOfBirth: false, }});
            }
        }
    }

    checkVals = () => {
        let allValid = Object.keys(this.state.validCheck).every((e) => this.state.validCheck[e]);
        if(allValid && this.state.hasAccepted){
            this.setState({disableBttn: false}); // Clickable button
        } else{
            this.setState({disableBttn: true}); // Disable button
        }
    }

    handleStuff = () => {
        this.setState({ showModal: true });
    }

    handleCancelNo = ()  => {
        this.setState({ showModal: false });
    }

    handleConfirmCancel = () => {
        this.props.history.push("/app");
    }

    renderPopUp() {
        return (
            <Modal
                    size="md"
                    show={this.state.showModal}
                    centered={true}
                    scrollable={true}
                    onHide={ () => this.handleCancelNo() }
                >
                    <Modal.Header closeButton>
                        <h5>{this.props.strings.REG_POPUP_HEADER}</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <h6>{this.props.strings.REG_POPUP_MESSAGE}</h6>
                    </Modal.Body>
                    <Modal.Footer className="regModal">
                        <div>
                            <button type="button" class="btn btn-primary custom-button" onClick={ () => this.handleConfirmCancel()} >{this.props.strings.REG_POPUP_CONFIRM}</button>
                            <button type="button" class="btn btn-secondary custom-button" onClick={ () => this.handleCancelNo()} >{this.props.strings.REG_POPUP_CANCEL}</button>
                        </div>
                    </Modal.Footer>
                </Modal>
        );
    }

    renderLoadingModal(){
        if (this.props.isLoadingRegister === true) {
            return (
                <Modal
                    size="lg"
                    show={true}
                    centered={true}
                    scrollable={true}
                    onHide={false}
                >
                    <Modal.Body>
                        <Loading />
                    </Modal.Body>
                </Modal>
            );
        } else {
            return null;
        }
    }

    renderError(key) {
        if (this.state.errors[key]){
            return (
                <div className="invalid-feedback d-block">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    renderRegisterError() {
        if (this.state.isRegisterError === false || this.state.registerErrorMessage === null) {
            return null;
        } else {
            return (
                <div>
                    <span style={{color: 'red', fontWeight: 'bold'}}>{this.props.strings.ERROR}{" "+this.state.errCode}: {this.state.registerErrorMessage}</span>
                </div>
            );
        }
    }

    render(){
        return (
            <div>
                <RegTitleCard />
                <br/>
                {this.renderRegisterError()}
                {this.renderLoadingModal()}
                {this.renderPopUp()}
                <form onSubmit={this.handleSubmit}>
                    <div className="regCards">
                        <div class="form-group required">
                            <h5><div class="addIcon"><img src={add} width="25" /></div>{this.props.strings.DEPENDENT_PAGE_HEADER}</h5>
                            <br/>
                            <div class="row">
                                <div class="col">
                                    <label class="control-label" for="regnum-input">
                                        {this.props.strings.DEPENDENT_REG_CODE_LABEL}<br/>
                                      <div class="subLabel">{this.props.strings.DEPENDENT_REG_CODE_SUB_LABEL}</div>
                                    </label>
                                    <input
                                        type="text" class={this.renderErrorClass('regNumber')+" col-md-4"}
                                        placeholder={this.props.strings.DEPENDENT_REG_CODE_PLACEHOLDER}
                                        onBlur={this.handleRegNumberChange}
                                        ref = {(input) => { this.regNumInput = input; }} 
                                    />
                                    {this.renderError('regNumber')}
                                </div>
                            </div>
                        </div>
                        <div class="form-group required">
                            <div class="row">
                                <div class="col">
                                    <label class="control-label" for="first-name-input">{this.props.strings.DEPENDENT_FIRST_NAME_LABEL}</label>
                                    <input
                                        value = {this.state.firstName}
                                        maxLength={50} class={this.renderErrorClass('firstName') + " form-control uppercase"} id="first-name-input"
                                        placeholder={this.props.strings.DEPENDENT_FIRST_NAME_PLACEHOLDER} onChange={this.handleFirstNameChange}
                                        onBlur={this.handleFinalFirstName} 
                                        ref = {(input) => { this.firstNameInput = input; }} 
                                    />
                                    {this.renderError('firstName')}
                                </div>
                                <div class="col">
                                    <label class="control-label" for="last-name-input">{this.props.strings.DEPENDENT_LAST_NAME_LABEL}</label>
                                    <input
                                        value = {this.state.lastName}
                                        maxLength={50} class={this.renderErrorClass('lastName') + " form-control uppercase"} id="last-name-input"
                                        placeholder={this.props.strings.DEPENDENT_LAST_NAME_PLACEHOLDER} onChange={this.handleLastNameChange}
                                        onBlur={this.handleFinalLastName} 
                                        ref = {(input) => { this.lastNameInput = input; }} 
                                    />
                                    {this.renderError('lastName')}
                                </div>
                            </div>
                        </div>
                        <div class="form-group required">
                            <label class="control-label" for="issuer-input">{this.props.strings.DEPENDENT_ISSUER_LABEL}</label>
                            <br/>
                            <select class="form-control" disabled="disabled" name="issuers" id="issuer-input" onChange={this.handleIssuerSelectChange} readOnly>
                                <option value="NB" defaultValue="selected">{this.props.strings.DEPENDENT_ISSUER_NB}</option>
                            </select>
                            {this.renderError('issuer')}
                        </div>
                        <div class="form-group required">
                            <div class="row">
                                <div class="col">
                                    <label class="control-label" for="medicare-input">{this.props.strings.DEPENDENT_PHIN_LABEL}</label>
                                    <input
                                        type="text" class={this.renderErrorClass('medicareNumber')} maxlength={9} id="medicare-input"
                                        placeholder={this.props.strings.DEPENDENT_PHIN_PLACEHOLDER} onChange={this.handleMedicareNumberChange}
                                        value={this.state.medicareNumber} onBlur = {this.checkFinalMedicareNumber}
                                        ref = {(input) => { this.medicareInput = input; }} 
                                    />
                                    {this.renderError('medicareNumber')}
                                </div>
                                <div class="col">
                                    <label class="control-label" for="dob-input">{this.props.strings.DEPENDENT_EXPIRATION_LABEL}</label>
                                    <div class="form-inline">
                                        <input
                                            class={this.renderErrorClass('expirationDateMonth') + " form-control"} type="text" id="month-input" maxlength={2} placeholder={this.props.strings.DEPENDENT_MONTH}
                                            onChange={this.handleExpirationDateMonth} value={this.state.expirationDateMonth} onBlur = {this.checkFinalExpirationDateMonth}
                                            ref = {(input) => { this.expiryMonthInput = input; }} 
                                        />
                                        <span class="forwardslash">/</span>
                                        <input
                                            class={this.renderErrorClass('expirationDateYear') + " form-control"} type="text" id="year-input" maxlength={4} placeholder={this.props.strings.DEPENDENT_YEAR}
                                            onChange={this.handleExpirationDateYear} value={this.state.expirationDateYear} onBlur = {this.handleFinalExpirationDateYear}
                                            ref = {(input) => { this.expiryYearInput = input; }} 
                                        />
                                    </div>
                                    {this.renderError('expirationDateMonth')}
                                    {this.renderError('expirationDateYear')}
                                </div>
                            </div>
                        </div>
                        <div class="form-group required">
                            <label class="control-label" for="dob-input">{this.props.strings.DEPENDENT_DOB_LABEL}</label>
                            <div class="form-inline">
                                <input class={this.state.errors.dobDay? this.renderErrorClass('dobDay'):this.renderErrorClass('dateOfBirth')}
                                    type="text" id="day-input" maxLength={2} placeholder={this.props.strings.DEPENDENT_DAY} onChange={this.handleDateOfBirthDayChange}
                                    onBlur={this.handleFinalDateOfBirthDay} value ={this.state.dobDay}
                                    ref = {(input) => { this.dobDayInput = input; }} 
                                />
                                <span class="forwardslash">/</span>
                                <input class={this.state.errors.dobMonth? this.renderErrorClass('dobMonth'):this.renderErrorClass('dateOfBirth')}
                                    type="text" id="month-input" maxLength={2} placeholder={this.props.strings.DEPENDENT_MONTH} onChange={this.handleDateOfBirthMonthChange}
                                    onBlur={this.handleFinalDateOfBirthMonthChange} value = {this.state.dobMonth}
                                    ref = {(input) => { this.dobMonthInput = input; }} 
                                />
                                <span class="forwardslash">/</span>
                                <input class={this.state.errors.dobYear? this.renderErrorClass('dobYear'):this.renderErrorClass('dateOfBirth')}
                                    type="text" id="year-input" maxLength={4} placeholder={this.props.strings.DEPENDENT_YEAR} onChange={this.handleDateOfBirthYearChange}
                                    onBlur ={this.handleFinalDateOfBirthYearChange} value = {this.state.dobYear}
                                    ref = {(input) => { this.dobYearInput = input; }} 
                                />
                                {this.renderError('dateOfBirth')}
                                {this.renderError('dobDay')}
                                {this.renderError('dobMonth')}
                                {this.renderError('dobYear')}
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className="regCardSubmit">
                        <div className="row justify-content-left">
                            <div class="control-label">{this.props.strings.DEPENDENT_AGREEMENT_MESSAGE}</div>
                            <ul>
                                <li>{this.props.strings.DEPENDENT_AGREEMENT_BULLET_1}</li>
                                <li>{this.props.strings.DEPENDENT_AGREEMENT_BULLET_2}</li>
                                <li>{this.props.strings.DEPENDENT_AGREEMENT_BULLET_3}</li>
                            </ul>
                        </div>
                        <br/>
                        <div className="row justify-content-center">
                            <div class="form-check agree">
                                <input class="form-check-input" type="radio" name="custody-input" id="custody-input" value="yes" checked={this.state.hasAccepted} onClick={() => this.checkAccepted()} />
                                <label class="form-check-label" for="custody-input">{this.props.strings.DEPENDENT_AGREE_BUTTON}</label>
                            </div>
                            {this.state.checkBoxError ===null ? <div></div>:<div className="center invalid-feedback d-block">{this.state.checkBoxError}</div>}
                        </div>
                        <br/>
                        <br/>

                        <div className="row justify-content-center">
                            <button
                                type="submit"
                                className = "btn btn-primary custom-button"
                                ref = {(input) => { this.sumitButton = input; }} 
                                // class={ this.state.disableBttn ? "btn btn-secondary custom-button":"btn btn-primary custom-button" }
                                // disabled={this.state.disableBttn}
                            >
                                {this.props.strings.DEPENDENT_SUBMIT_BUTTON}
                            </button>
                            <span class="hyphen"></span>
                            <button type="button" class="btn btn-secondary custom-button" onClick={ () => this.handleStuff()} >{this.props.strings.DEPENDENT_CANCEL_BUTTON}</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
        isLoadingRegister: state.auth.isLoadingRegister,
    }
}

const ConnectedDependentForm = connect(
    mapStateToProps
)(DependentForm);

export default withRouter(ConnectedDependentForm);